import { Box, Typography } from '@mui/material';
import { styles } from './styles';
import success_background from '../../assets/success/success_background.svg';
import check from '../../assets/success/check.svg';
import logo from '../../assets/success/logo.svg';
import Button from '../button/Button';

interface SuccessInputs {
  title: string;
  description: string;
  buttonTitle: string;
  onButtonClick: () => void;
}

export const Success = ({
  title,
  description,
  buttonTitle,
  onButtonClick,
}: SuccessInputs) => {
  const textSuccess = (
    <Box sx={styles.contentContainer}>
      <Box component="img" alt="" src={check} sx={styles.checkIcon} />
      <Typography sx={styles.textTitle}>{title}</Typography>
      <Typography sx={styles.textDescription}>{description}</Typography>
      <Box component="img" alt="" src={logo} sx={styles.medStationIcon} />
    </Box>
  );

  return (
    <Box sx={styles.container}>
      <Box
        component="img"
        src={success_background}
        sx={styles.successBackground}
      />
      <Box sx={styles.overlay}>
        {textSuccess}
        <Button
          onClick={onButtonClick}
          title={buttonTitle}
          sx={styles.button}
          color="none"
        />
      </Box>
    </Box>
  );
};
